document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.smooth-dropdown').forEach(dropdown => {
      const summary = dropdown.querySelector('.smooth-dropdown__summary');
      const content = dropdown.querySelector('.smooth-dropdown__content');
  
      // Remove the initial class after a short delay
      setTimeout(() => {
        dropdown.classList.remove('smooth-dropdown--initial');
      }, 100);
  
      summary.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent the default toggle behavior
  
        if (dropdown.open) {
          // Closing
          content.style.maxHeight = content.scrollHeight + 'px';
          setTimeout(() => {
            content.style.maxHeight = '0';
            content.style.opacity = '0';
          }, 10);
  
          setTimeout(() => {
            dropdown.open = false;
          }, 300); // Match this with your transition duration
        } else {
          // Opening
          dropdown.open = true;
          content.style.maxHeight = (content.scrollHeight + 5) + 'px';
          content.style.opacity = '1';
        }
      });
    });
  });
  